<template>
  <div id="page-wrap">
   <b-navbar fixed="top" class="HeaderBackground" toggleable="lg" type="light" variant="white">
     <b-navbar-brand to="/"><b-img height="40" :src="image" />  Portal  </b-navbar-brand>


    <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
      
      
    <b-collapse is-nav id="nav_collapse">
     
      <!-- Right aligned nav items -->
      <!-- LOGGED-IN NAVIGATION -->
      <b-navbar-nav class="ml-auto">
        <template v-if="isAuthenticated">

          <b-overlay
            :show="loadingData"
            rounded
            opacity="0.6"
            spinner-small
            spinner-variant="primary"
            class="d-inline-block"
          >
            <b-nav-item right href="#"> 
                <b-dropdown  variant="primary">
                <template v-slot:button-content>
                      <v-icon class="icon" name="download"></v-icon>Download       
                </template>
            
                  <b-dropdown-item @click="GetCSVfromServer">CSV</b-dropdown-item>
                  <b-dropdown-item @click="GetJSONfromServer">JSON</b-dropdown-item>
                </b-dropdown>
            </b-nav-item>
          </b-overlay>



         <b-nav-item right href="#"> <b-button variant="primary" @click="logout"> <v-icon class="icon" name="power"></v-icon> Log out </b-button> </b-nav-item>

        </template>

        <template v-else>
          <!-- LOGGED-OUT NAVIGATION -->
          <b-nav-item to="login">Login</b-nav-item>
        </template>
      </b-navbar-nav>

     </b-collapse>

    </b-navbar>

    
    
 
  <router-view/>


    <footer id="page-footer" class="navbar navbar-light justify-content-between flex-row-reverse">
      <div class="nav">
        <small class="nav-item"><a class="nav-link text-info" href="https://medusa-online.com/en/contact/">Contact<span class="d-none d-sm-inline"> us</span></a></small>
        <template v-if="isAuthenticated">
        <small class="nav-item">
          <a class="nav-link text-info" href="#" @click.prevent.stop="logout">Sign out</a></small>
        </template>
      </div>
      <small class="copy">Medusa Radiometrics &copy; </small>
    </footer>



  </div>

</template>






<script>


import FileDownload from 'js-file-download';
import logo from '@/assets/logo.png'
import { mapGetters } from 'vuex'
import { AUTH_LOGOUT } from '@/store/actions/auth'


import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import Vuelidate from 'vuelidate'

Vue.use(Vuelidate)
Vue.use(BootstrapVue)

export default {
  name: 'App',
  data() {
    return {
      image: logo,
      serial : "gSMS",
      loadingData : false,
      selectedSensor : ''

    }
  },
  computed: {
    ...mapGetters(['isAuthenticated', 'authStatus', 'hasRole', 'hasSignature', 'getProfile']), 

  },
  methods: {
    logout () {
      const { email, password } = this
      this.$store.dispatch(AUTH_LOGOUT, { email, password }).then(() => {
        this.$router.push('/login')
      })
    }, 
    DownloadErrorToast(Err) {
      this.$bvToast.toast(`Error while generating download. ${Err}`, {
        title: 'Download message',
        autoHideDelay: 5000,
        variant: 'danger',
        toaster: 'b-toaster-bottom-right',
        solid: true,
      })
    },
    GetJSONfromServer(){
        if (typeof this.$store.getters.getSensorSelected.id == 'undefined') {return}

        this.loadingData = true;

        return this.$http.get(`/api/v1/data/download/json/`+ this.$store.getters.getSensorSelected.id).then(response => {
        
        this.loadingData = false;
        let  timestamp = new Date();

        if (response.data.length == 0 ){ throw "no data"}

        let output = []
        response.data.forEach(element => {
          output.push("[" + JSON.stringify(element) + "]")
        });

        let data2Download = output.join('\r\n').toString()

        let FileName = this.$store.getters.getSensorSelected.e_id + " " + timestamp.toISOString() + ".json"
        FileDownload(data2Download, FileName)
      
        return 
      }).catch(error => {
        this.DownloadErrorToast(error)
        // reset the loading state
        this.loadingData = false;

        // to do: generate an error to display
        return 
      }) 

    },
    GetCSVfromServer() {
        if (typeof this.$store.getters.getSensorSelected.id == 'undefined') {return}

        this.loadingData = true;


        return this.$http.get(`/api/v1/data/download/`+ this.$store.getters.getSensorSelected.id).then(response => {
        
        this.loadingData = false;
        let  timestamp = new Date();
        
        
        let FileName = this.$store.getters.getSensorSelected.e_id + " " + timestamp.toISOString() + ".csv"
        FileDownload(response.data, FileName)
      
        return 
      }).catch(error => {
        this.DownloadErrorToast(error)
        // reset the loading state
        this.loadingData = false;

        // to do: generate an error to display
        return 
      }) 

    }, 

  },

  created: async function () {
    // if (this.$store.getters.isAuthenticated) {
    //   await this.$store.dispatch(USER_REQUEST)
    // }
    this.$http.interceptors.response.use(undefined, function (err) {
      return new Promise(function (resolve, reject) {
        if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
        // if you ever get an unauthorized, logout the user
          this.$store.dispatch(AUTH_LOGOUT)
        // you can also redirect to /login if needed !
        }
        throw err
      })
    })
  }
}
</script>



<style lang="scss">
$eva-green:#397d3a;
$eva-grey:#5a6771;
$eva-white:#ffffff;
$body-bg: $eva-white;
$body-color: $eva-grey;
$theme-colors: (
  'eva-green':  $eva-green
);

body {
    padding-top: 70px;
    padding-bottom: 70px;
    margin-bottom: 50px; /* Margin bottom by footer height */
}

html {
  position: relative;
  min-height: 100%;
}

#page-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  // width: 100%;
  height: 50px; /* Set the fixed height of the footer here */
  line-height: 25px; /* Vertically center the text there */
  background-color: #f5f5f5;
}

.custom-file-label {
  overflow: hidden;
}

.icon {
    width: 24px;
    color: white;
}

 .HeaderBackground {
   border: 1px solid rgba(211,211,211,0.5);
 }



@import "~bootstrap/scss/bootstrap";
@import '~bootstrap-vue/dist/bootstrap-vue.css';
</style>
